import { Add, Close } from "@mui/icons-material";
import {
  Box,
  Button,
  IconButton,
  Link,
  Paper,
  Typography,
} from "@mui/material";
import { FAKE_TEXT } from "helpers/constants";
import { EntitySelector } from "modals/EntitySelector";
import { COMPETENCY_REQUIREMENTS } from "pages/Requirements/portal/data";
import { FC, useState } from "react";
import { getFilteredList } from "utils/Array";

type Step2Props = {
  requirements: any[];
  onUpdateRequirements: (requirements: any[]) => void;
};

export const Step2: FC<Step2Props> = ({
  requirements,
  onUpdateRequirements,
}) => {
  const [openEntitySelector, setOpenEntitySelector] = useState(false);
  const handleRemoveRequirement = (reqId: string) => {
    const newRequirements = requirements.filter(
      (requirement) => requirement.reqId !== reqId,
    );
    onUpdateRequirements(newRequirements);
  };
  return (
    <>
      <Typography variant="h4" gutterBottom>
        Prepare by Reviewing Competency Goals
      </Typography>
      <Typography variant="body1" gutterBottom>
        {FAKE_TEXT.LONG2X}
      </Typography>

      <Typography variant="h5">Competency Skill to be Observed</Typography>

      {requirements.length === 0 && (
        <Box mt={2}>
          <Typography variant="body1" color="textSecondary">
            No requirements added yet
          </Typography>
        </Box>
      )}

      <Box>
        {requirements.map((requirement) => (
          <Box>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                my: 2,
                background: "rgba(0,0,0,0.1)",
                position: "relative",
              }}
            >
              <IconButton
                sx={{ position: "absolute", top: -1, right: 0 }}
                onClick={() => {
                  handleRemoveRequirement(requirement.reqId);
                }}
              >
                <Close />
              </IconButton>
              <Typography variant="body1" fontWeight={600}>
                {requirement.requirementName}
              </Typography>
              <Typography variant="body1">
                {requirement.fullDescription}
              </Typography>
              <Box display="flex" justifyContent="flex-end">
                <Link>See Success Rubric</Link>
              </Box>
            </Paper>
          </Box>
        ))}
      </Box>

      <Box mt={2}>
        <Button
          variant="outlined"
          onClick={() => {
            setOpenEntitySelector(true);
          }}
          startIcon={<Add />}
        >
          Add Skill
        </Button>
      </Box>

      <EntitySelector
        open={openEntitySelector}
        onClose={() => setOpenEntitySelector(false)}
        title={"Select Requirements"}
        listEntities={getFilteredList(
          COMPETENCY_REQUIREMENTS, // TODO: Replace with API once available
          requirements,
          "reqId",
        )}
        filterCriteria={(search: string, data: any) =>
          data.requirementName.toLowerCase().includes(search.toLowerCase())
        }
        onSelect={(selected: any) => {
          onUpdateRequirements([...requirements, selected]);
        }}
        displayField="requirementName"
        keyField="reqId"
      />
    </>
  );
};
